/**
*
*   Stockist form
*       - A Stockist Signup / Inquiry Form
*
**/
'use client';

import Preloader from '@/components/preloader';
import Button from '@/components/button';
import Storefront from '@/libraries/shopify/class';
import PageLoader from '@/libraries/pageloader';
import { useState, useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { signIn, getCsrfToken } from 'next-auth/react';
import { useRouter } from 'next/navigation';


//Build the Element
export default function CreateAccount(){

	const { control, register, setError, formState: { errors, isSubmitting, isSubmitSuccessful }, handleSubmit } = useForm();
	const [ csrfToken , setCsrfToken ] = useState(null);
	const [ loading , setLoading ] = useState(false);
	const [ running , setRunning ] = useState(false);
	const t = useTranslations();
	const router = useRouter();

	//Form Settings
	const Form = {

		//Settings
		email: {
			validate: email => /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email) || t('Forms.Errors.email.invalid')
		},

		//Error
		error: ({ message }) =>(<p className="error">{ message }</p> ),

		//A Thrown Error Message
		thrown: ( message ) => setError('root.serverError',{
			type: 500,
			message: `${ t('errors.unknown')  } ${  message }`
		}),

		//On Submit
		submit: async data => {

			//Create the Customer
			const customer = await Storefront.Customer.create(data);

			//
			if( !customer.result )
				return setError('root.serverError',{
					type: 500,
					message: customer.errors.map( (e,i) => (<p key={i}>{ e.message }</p>) )
				});

			//Set Loading
			setLoading(true);

			//Sign in to the new customer
			signIn('credentials',{
				email:      data.email,
				password:   data.password,
				redirect:   false
			}).then( ({ ok, error })=>{

				//Redirect on Success
				if( ok ){

					PageLoader.start();

					router.push('/account');

				}

				setRunning(false);

				//Error
				if( !ok && error )
					setError(
						'root.serverError',
						((e) => {
							try {

								//Get the JSON and format
								error   = JSON.parse(error);
								e       = {
									type:       ( error.status || e.type ),
									message:    error.errors.map( (e,i) => (<p key={i}>{ e.message }</p>) )
								};

							} catch( err ){
							}

							return e;
						})({
							type:       500,
							message:    ( t('Forms.Errors.unknown') ).replace(':','')
						})
					);
			});
		}
	};

	//Get the CSRF Token
	useEffect(() => {
		getCsrfToken().then( (token) => {
			setCsrfToken(token || null);
		});
	}, []);

	return (
		<form id="register-form" onSubmit={ handleSubmit(Form.submit) }>

			{/* Show Preloader on Login */}
			<Preloader status={ loading } />

			{/* Submission Response Error */}
			{ errors.root?.serverError?.type > 200 && (
				<div className="failed">{
					errors.root.serverError.message
				}</div>
			) }

			{/* Row1 */}
			<div className="row">
				<div>
					<label htmlFor="firstName">{ t('Forms.Labels.firstname') }</label>
					<input name="firstName" type="firstName" placeholder={ `${ t('Forms.Labels.firstname')  }*` } {...register('firstName', { required:  t('Forms.Errors.required',{ type: t('Forms.Labels.firstname') }) })} />
					<ErrorMessage errors={errors} name="firstName" render={ Form.error } />
				</div>
			</div>

			{/* Row2 */}
			<div className="row">
				<div>
					<label htmlFor="lastName">{ t('Forms.Labels.lastname') }</label>
					<input name="firstName" type="lastname" placeholder={ `${ t('Forms.Labels.lastname')  }*` } {...register('lastName', { required:  t('Forms.Errors.required',{ type: t('Forms.Labels.lastname') }) })} />
					<ErrorMessage errors={errors} name="lastName" render={ Form.error } />
				</div>
			</div>

			{/* Row3 */}
			<div className="row">
				<div>
					<label htmlFor="email">{ t('Forms.Labels.email') }</label>
					<input name="email" placeholder={ `${ t('Forms.Labels.email')  }*` } {...register('email', { required: t('Forms.Errors.required',{ type: t('Forms.Labels.email') }), validate: Form.email.validate })} />
					<ErrorMessage errors={errors} name="email" render={ Form.error } />
				</div>
			</div>

			{/* Row4 */}
			<div className="row">
				<div>
					<label htmlFor="password">{ t('Forms.Labels.password') }</label>
					<input name="password" type="password" placeholder={ `${ t('Forms.Labels.password')  }*` } {...register('password', { required:  t('Forms.Errors.required',{ type: t('Forms.Labels.password') }) })} />
					<ErrorMessage errors={errors} name="password" render={ Form.error } />
				</div>
			</div>

			{/* Submit */}
			<div className="row submit">
				<div>
					<input name="csrfToken" type="hidden" defaultValue={csrfToken} />
					<Button disabled={ isSubmitting || running } button type="submit">{ t('Pages.Register.button') }</Button>
				</div>
			</div>

		</form>
	);

}